var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.411,
    height: 16.225,
    viewBox: "0 0 16.411 16.225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-rename-1561912",
    transform: "translate(-197.07 -128.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7904",
    "data-name": "Path 7904",
    d: "M206.817,141.427h6.664v3.59H203.229Zm-9.747.21,9.969-9.973,3.38,3.38-9.969,9.972h-3.38Zm15.97-9.212-1.647,1.649-3.38-3.38,1.647-1.649a.869.869,0,0,1,.634-.252.859.859,0,0,1,.634.252l2.1,2.1a.9.9,0,0,1,0,1.265Z",
    transform: "translate(0 0)",
    fill: "#4EB6EE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.2f1776a5be322e17068971ce1fea8ff5.svg";
export { ForwardRef as ReactComponent };